// Fetch Helper
import axios from "axios";

export const ERequestType = {
	USERS: {
		REGISTER: "user/register",
		LOGIN: "user/login",
		GET: "user/userByID",
		GETALL: "user/users",
		CHECK_PWD: "user/checkPWD",
		CHANGE_PWD: "user/changePWD",
		DELETE: "user/delete",
	},
	USERSINFOS: "userInfos",
	CLIENTS: {
		ALL: "client/clients",
		BY_PAGE: "client/clientsByPage",
		CHECK: "client/checkClient",
		GET_BY_CID: "client/getClientByCid",
		GET_TAB_BY_CIDS: "client/getTabOfClientsByCids",
		CREATE: "client/add",
		UPDATE: "client/update",
		UPDATEBYCID: "client/updateByCid",
		SEARCH: "client/search",
	},
	SERVICES: {
		ALL: "services/services",
		CREATE: "services/add",
		UPDATE: "services/update",
		DELETE: "services/delete",
		LOCKED_DAYS: "lockedservices/lockedservices",
		ADD_LOCKED_DAYS: "lockedservices/add",
		DELETE_LOCKED_DAYS: "lockedservices/delete",
	},
	FORKBOOKING: {
		GET_AVAILABLE_DAYS: "forkBooking/getAvailableDays",
		GET_AVAILABLE_PLACES: "forkBooking/getAvailablePlaces",
		GET_AVAILABLE_TABS: "forkBooking/getAvailableTabs",
		GET_PRESELECTED_STEPS: "forkBooking/getPreselectedSteps",
	},
	EVENTS: {
		ALL: "events/events",
		GET_BY_ID: "events/getById",
		VISIBLE: "events/visible",
		CREATE: "events/add",
		UPDATE: "events/update",
		DELETE: "events/delete",
	},
	DISCOUNT: {
		ALL: "discount/discount",
		GET_BY_ID: "discount/getById",
		CREATE: "discount/add",
		UPDATE: "discount/update",
		DELETE: "discount/delete",
	},
	CASHDAYS: {
		ALL: "cashdays/cashdays",
		CHECK: "cashdays/checkCashdays",
		GET_BY_TS_SERVICE: "cashdays/getCashdaysByTsAndService",
		CREATE: "cashdays/add",
		UPDATE: "cashdays/update",
		DELETE: "cashdays/delete",
	},
	CASHRESAS: {
		GET_BY_ID: "cashresas/getCashresasByid",
		GET_BY_SID: "cashresas/getCashresasBySid",
		CREATE: "cashresas/create",
		UPDATE: "cashresas/updateById",
		DELETE: "cashresas/delete",
		ALL_UNPAID: "cashresas/cashResasUnPaid",
		ALL_PAID_FROM: "cashresas/cashResasPaidFromDate",
	},
	RESAS: {
		CREATE: "resas/create",
		UPDATE: "resas/update",
		LAZY_UPDATE: "resas/lazyupdate",
		DELETE: "resas/delete",
		GET_BY_TS: "resas/getResasByTs",
		GET_CLIENT_BY_TS: "resas/getClientsByTs",
		GET_BY_TS_SERVICE: "resas/getResasByTsAndService",
		GET_CURRENT_FUTURE: "resas/getResasCurrentAndFuture",
		GET_CLIENT_CURRENT_FUTURE: "resas/getClientCurrentAndFuture",
		GET_TS_TO_TS: "resas/getResasTsToTs",
		GET_CLIENT_TS_TO_TS: "resas/getClientsTsToTs",
		GET_TS_COUV_BY_HOUR: "resas/getCouvByTsAndHour",
		GET_ALL_TS_TO_TS: "resas/getAllResasTsToTs",
		GET_BY_ID: "resas/getResasById",
		GET_ALL_BY_CID: "resas/getCidResasByResto",
		GET_ALL: "resas/resas",
	},
	ROOMS: {
		CREATE: "rooms/create",
		UPDATE: "rooms/update",
		DELETE: "rooms/delete",
		GET_ALL: "rooms/rooms",
		GET_BY_ID: "rooms/getRoomsById",
		GET_CAPCITY: "rooms/capacity",
		LOCKED_ROOMS: "lockedrooms/lockedrooms",
		ADD_LOCKED_ROOMS: "lockedrooms/add",
		DELETE_LOCKED_ROOMS: "lockedrooms/delete",
	},
	TABLES: {
		CREATE: "tables/create",
		UPDATE: "tables/update",
		UPDATE_ID: "tables/updateId",
		DELETE: "tables/delete",
		DELETE_BY_ROOM: "tables/deleteRoomTables",
		GET_BY_ROOMID: "tables/tablesByRoom",
		GET_BY_ID_ROOMID: "tables/getTablesByIdAndRoom",
		LOCKED_TABLES: "lockedtables/lockedtables",
		UPDATE_LOCKED_TABLES: "lockedtables/update",
	},
	INFOS: {
		CREATE: "restoInfos/create",
		UPDATE: "restoInfos/update",
		UPDATEREVIEWS: "restoInfos/updateReviews",
		DELETE: "restoInfos/delete",
		GET: "restoInfos/getRestoInfos",
		GETALL: "restoInfos/getAllRestoInfos",
	},
	TAGS: {
		CREATE: "tags/create",
		UPDATE: "tags/update",
		DELETE: "tags/delete",
		GET: "tags/tags",
	},
	APPINFOS: {
		UPDATE: "appInfos/update",
		GET: "appInfos/appInfos",
	},
	MAILER: {
		S_RESA_CONFIRMED: "mailer/sendResaConfirmedMail",
		S_RESA_ASK_REVIEW: "mailer/sendReviewMail",
		S_RESA_PRE_CONFIRMED: "mailer/sendResaPreConfirmedMail",
		S_RESA_CONFIRMED_RESTO: "mailer/sendResaToConfirmRestaurateur",
		S_RESA_TAKED_RESTO: "mailer/sendResaTakedRestaurateur",
		S_RESA_MODIFY: "mailer/sendResaModifyMail",
		S_RESA_CANCELLED: "mailer/sendResaCancelledMail",
		S_RESA_CANCELLED_RESTO: "mailer/sendResaCancelRestaurateur",
		S_RESA_MODIFY_RESTO: "mailer/sendResaModifyRestaurateur",
		S_RESA_PAIEMENTFAIL_RESTO: "mailer/sendResaEchecPaiementRestaurateur",
		S_RESA_PAIEMENTFAIL: "mailer/sendResaEchecPaiement",
	},
	SMS: {
		S_RESA_CONFIRMED: "sms/sendResaConfirmedSms",
		S_RESA_PRE_CONFIRMED: "sms/sendResaPreConfirmedSms",
		S_RESA_CANCELLED: "sms/sendResaCancelledSms",
		GET_ALL_TS_TO_TS: "sms/getAllSmsTsToTs",
	},
	REDIRECT: {
		GET: "redirect/get",
	},
	STATS: {
		GET_BY_DATES: "stats/getStatsByDates",
	},
	STRIPE: {
		GET_CUSTOMER: "stripe/customers",
		GET_PAYMENT_INTENT: "stripe/paymentIntent",
		GET_SETUP_INTENT: "stripe/setupIntent",
		CHECKOUT_P_AUTO: "stripe/checkoutPAuto",
		CHECKOUT_APP: "stripe/checkoutApp",
		CHECKOUT: "stripe/checkout",
	},
	GOOGLE: {
		POST_CONVERSION: "google/conversion",
	},
};

/**
 * Fetch data from back POST Method
 * @param pRequestType: Json Datas Pass to fetch post
 * @param pJsonDatas: Json Datas Pass to fetch post
 */
export const fetchPostHelper = async function (pRequest, pJsonDatas, token) {
	// Build request url
	const baseRequest = [
		// base url
		import.meta.env.VITE_BACK_URL,
		// base api
		// 'api',
		// string request after type, ex: get/establishment
		`/${pRequest}`,
		// token
		// "?token=", token,
	].join("");

	// Return promise
	return new Promise((resolve, reject) => {
		// await fetch
		axios
			.post(baseRequest, pJsonDatas, {
				headers: {
					authorization: `Bearer ${token}`,
				},
			})
			.then((res) => {
				resolve(res);
			})
			// catch error on request
			.catch((error) => {
				reject(error.response);
			});
		// request succed return result
	});
};

/**
 * Fetch data from back PUT Method
 * @param pRequestType: Json Datas Pass to fetch post
 * @param pJsonDatas: Json Datas Pass to fetch post
 */
export const fetchPutHelper = async function (pRequest, pJsonDatas, token) {
	// Build request url
	const baseRequest = [
		// base url
		import.meta.env.VITE_BACK_URL,
		// base api
		// 'api',
		// string request after type, ex: get/establishment
		`/${pRequest}`,
		// token
		// "?token=", token,
	].join("");

	// Return promise
	return new Promise((resolve, reject) => {
		// await fetch
		axios
			.put(baseRequest, pJsonDatas, {
				headers: {
					authorization: `Bearer ${token}`,
				},
			})
			.then((res) => {
				resolve(res);
			})
			// catch error on request
			.catch((error) => {
				reject(error.response);
			});
		// request succed return result
	});
};

/**
 * Fetch data from back GET Method
 * @param pRequestType: Json Datas Pass to fetch post
 * @param pJsonDatas: Json Datas Pass to fetch post
 */
export const fetchGetHelper = async function (pRequest, params, token) {
	// Build request url
	const baseRequest = [
		// base url
		import.meta.env.VITE_BACK_URL,
		// base api
		// 'api',
		// string request after type, ex: get/establishment
		`/${pRequest}`,
		// params
		params && params !== "" ? `?${params}` : "",
		// token
		// "?token=", token,
	].join("");

	// Return promise
	return new Promise((resolve, reject) => {
		// await fetch
		axios
			.get(baseRequest, {
				headers: {
					authorization: `Bearer ${token}`,
				},
				crossdomain: true,
			})
			.then((res) => {
				resolve(res);
			})
			// catch error on request
			.catch((error) => {
				console.error("GET request Error", error);
				reject(error.response);
			});
	});
};

/**
 * Fetch data from back PUT Method
 * @param pRequestType: Json Datas Pass to fetch post
 * @param pJsonDatas: Json Datas Pass to fetch post
 */
export const fetchDeleteHelper = async function (pRequest, pJsonDatas, token) {
	// Build request url
	const baseRequest = [
		// base url
		import.meta.env.VITE_BACK_URL,
		// base api
		// 'api',
		// string request after type, ex: get/establishment
		`/${pRequest}`,
		// token
		// "?token=", token,
	].join("");

	// Return promise
	return new Promise((resolve, reject) => {
		// await fetch
		// const response = axios.post(baseRequest, pJsonDatas)
		axios
			.delete(baseRequest, pJsonDatas, {
				headers: {
					authorization: `Bearer ${token}`,
				},
			})
			.then((res) => {
				resolve(res);
			})
			// catch error on request
			.catch((error) => {
				reject(error.response);
			});
		// request succed return result
	});
};
